(function () {
  var CFG = window.S91 || {};
  var FREE_SHIP_CENTS = (CFG.freeShip || 0) * 100;
  var money = (function () {
    var cur = CFG.currency || 'USD';
    try {
      var nf = new Intl.NumberFormat(undefined, { style: 'currency', currency: cur });
      return function (cents) { return nf.format((cents || 0) / 100); };
    } catch (e) {
      return function (cents) { return (cents / 100).toFixed(2); };
    }
  })();

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Nav scroll state (home only) ---------- */
  var shell = $('.s91-shell');
  var nav = $('.s91-nav');
  var topbar = $('.s91-topbar');
  function setTopbarH() {
    if (topbar) document.documentElement.style.setProperty('--s91-topbar-h', topbar.offsetHeight + 'px');
  }
  setTopbarH();
  window.addEventListener('resize', setTopbarH);
  if (nav && shell && !shell.classList.contains('s91-shell--solid')) {
    var onScroll = function () {
      nav.classList.toggle('scrolled', window.scrollY > (topbar ? topbar.offsetHeight : 28) - 6);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Toast ---------- */
  var toastEl = $('.s91-toast');
  var toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('.s91-cart-drawer');
  var overlay = $('.s91-cart-overlay');
  var fab = $('.s91-cart-fab');
  var itemsEl = $('[data-cart-items]');
  var emptyEl = $('[data-cart-empty]');
  var upsellWrap = $('[data-upsell]');
  var upsellList = $('[data-upsell-list]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('show'); }); }
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('show'); setTimeout(function () { overlay.hidden = true; }, 400); }
    document.body.style.overflow = '';
  }
  $all('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  var closeBtn = $('[data-cart-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeCart();
  });

  /* ---------- Cart API ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addItem(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function changeItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function render(cart) {
    var count = cart.item_count;
    $all('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    if (fab) fab.hidden = count === 0;

    if (itemsEl) {
      $all('.s91-cart-line', itemsEl).forEach(function (n) { n.remove(); });
      if (emptyEl) emptyEl.hidden = count > 0;
      cart.items.forEach(function (it) {
        var line = document.createElement('div');
        line.className = 's91-cart-line';
        var thumb = it.image
          ? '<img src="' + it.image + '" alt="">'
          : '';
        line.innerHTML =
          '<div class="s91-cart-line__thumb">' + thumb + '</div>' +
          '<div class="s91-cart-line__info"><h4>' + it.product_title + '</h4>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="font-size:.72rem;color:var(--s91-bone-dim);margin-bottom:.3rem">' + it.variant_title + '</div>' : '') +
          '<div class="s91-cart-line__qty"><button data-dec="' + it.key + '">\u2212</button><span>' + it.quantity + '</span><button data-inc="' + it.key + '">+</button></div>' +
          '<button class="s91-cart-line__rm" data-rm="' + it.key + '">Remove</button></div>' +
          '<div class="s91-cart-line__price">' + money(it.final_line_price) + '</div>';
        itemsEl.appendChild(line);
      });
    }

    // Upsell: injected pool minus items already in cart
    if (upsellWrap && upsellList) {
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.product_id] = true; });
      var pool = (CFG.upsell || []).filter(function (p) { return !inCart[p.productId]; }).slice(0, 2);
      upsellWrap.hidden = count === 0 || pool.length === 0;
      upsellList.innerHTML = pool.map(function (p) {
        return '<div class="s91-cart-upsell__item"><div class="s91-cart-upsell__thumb">' +
          (p.image ? '<img src="' + p.image + '" alt="">' : '') + '</div>' +
          '<div class="s91-cart-upsell__meta"><h5>' + p.title + '</h5><span>' + money(p.price) + '</span></div>' +
          '<button class="s91-cart-upsell__add" data-up="' + p.variantId + '">Add +</button></div>';
      }).join('');
    }

    // Free shipping bar
    var shipEl = $('[data-ship]');
    var barEl = $('[data-ship-bar]');
    if (shipEl && barEl && FREE_SHIP_CENTS > 0) {
      var remaining = Math.max(0, FREE_SHIP_CENTS - cart.total_price);
      barEl.style.width = Math.min(100, (cart.total_price / FREE_SHIP_CENTS) * 100) + '%';
      if (remaining <= 0) {
        shipEl.classList.add('free');
        shipEl.textContent = "You've unlocked free shipping \u2713";
      } else {
        shipEl.classList.remove('free');
        shipEl.innerHTML = 'Add <b>' + money(remaining) + '</b> for free shipping';
      }
    }

    var totalEl = $('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function refresh() { return getCart().then(render); }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      var key;
      if ((key = t.getAttribute('data-inc'))) { bump(key, 1); }
      else if ((key = t.getAttribute('data-dec'))) { bump(key, -1); }
      else if ((key = t.getAttribute('data-rm'))) { setLine(key, 0); }
      else if ((key = t.getAttribute('data-up'))) {
        addItem(key, 1).then(function () { return refresh(); }).then(openCart).catch(function () { toast('Could not add item.'); });
      }
    });
  }
  function lineQty(key) {
    return getCart().then(function (c) {
      var found = c.items.filter(function (i) { return i.key === key; })[0];
      return found ? found.quantity : 0;
    });
  }
  function bump(key, delta) {
    lineQty(key).then(function (q) { return changeItem(key, Math.max(0, q + delta)); }).then(render);
  }
  function setLine(key, qty) { changeItem(key, qty).then(render); }

  /* ---------- Intercept add-to-cart forms (cards + product page) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) return;
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    var btn = form.querySelector('[type="submit"]');
    addItem(idField.value, qty).then(function () {
      return refresh();
    }).then(function () {
      if (btn) {
        var orig = btn.textContent;
        btn.textContent = 'Added \u2713';
        btn.classList.add('added');
        setTimeout(function () { btn.textContent = orig; btn.classList.remove('added'); }, 1200);
      }
      openCart();
    }).catch(function () { toast('Could not add to cart.'); });
  });

  /* ---------- Search (Shopify predictive search) ---------- */
  var search = $('.s91-search');
  var searchInput = $('#s91SearchInput');
  var searchResults = $('#s91SearchResults');
  var searchT;
  function openSearch() {
    if (!search) return;
    search.classList.add('open');
    search.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 60);
  }
  function closeSearch() {
    if (!search) return;
    search.classList.remove('open');
    search.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
  }
  function runSearch(q) {
    if (!searchResults) return;
    if (!q) { searchResults.innerHTML = ''; return; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (data) {
      var items = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!items.length) {
        searchResults.innerHTML = '<p class="s91-search__empty">No matches for "' + q + '". Try "hoodie" or "hat".</p>';
        return;
      }
      searchResults.innerHTML = items.map(function (p) {
        return '<a class="s91-search__hit" href="' + p.url + '"><h4>' + p.title + '</h4><span>' + (p.price ? money(parseInt(p.price, 10)) : '') + '</span></a>';
      }).join('');
    }).catch(function () {
      searchResults.innerHTML = '<p class="s91-search__empty">Search is unavailable right now.</p>';
    });
  }
  $all('[data-search-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
  });
  var searchClose = $('[data-search-close]');
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (search) search.addEventListener('click', function (e) { if (e.target === search) closeSearch(); });
  if (searchInput) searchInput.addEventListener('input', function (e) {
    clearTimeout(searchT);
    var v = e.target.value;
    searchT = setTimeout(function () { runSearch(v); }, 220);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && search && search.classList.contains('open')) closeSearch();
  });

  /* ---------- Init ---------- */
  refresh();
})();
